import {addClass, makeElement, insertBefore} from '../../common/Utils';
import { ncBannerOptions } from '../../interface/ICommonbanner';

/**
 * @category Commonbanner
 * @description
 * 상단 띠배너 배너
 * 메인페이지에서만 노출
 * D-DAY 표시 및 버튼 노출 기능
 */

class TopLayer {    
    bannerEl!: HTMLElement;
    el!: HTMLElement;
    constructor(_isMain: boolean= false, _isLauncher: boolean = false, _data: ncBannerOptions) {

        if( !_isMain || !_data.showTopBanner){
            return;
        }

        if ( _isLauncher && !_data.topLauncherShow) {
            return;
        }        

        this.bannerEl = this.template(_data);
        document.body.insertBefore( this.bannerEl, document.body.childNodes[0]);     

        if(_data.ddayShow && _data.ddayDate) {
            const dday = new Date(parseInt(_data.ddayDate.substring(0,4)), parseInt(_data.ddayDate.substring(4,6))-1, parseInt(_data.ddayDate.substring(6,8)));
            const dayNow = new Date();
            const timeDiff = dday.getTime() - dayNow.getTime();
            const dayDiff = Math.ceil(timeDiff/(1000 * 60 * 60 * 24));            

            if(dayDiff < 0) {     
                this.bannerEl.remove();               
                return;
            }            

            const ncbannerdate = document.querySelector('.nc-banner-date') as HTMLElement;
            const bannerdatenum = document.querySelector('.banner-date-num') as HTMLElement;

            if(dayDiff === 0) {
                if(this._isLangJa){
                    ncbannerdate.style.display = 'none'
                }else{
                    bannerdatenum.innerHTML = 'DAY';
                }
            } else {
                bannerdatenum.innerHTML = String(dayDiff);
            }            
           
        }

        addClass( this.bannerEl , 'is-show'); 
        
        

        // todo. 저해상도에서 위치를 잘 잡지 못해 cnb 호출
        //window.cnb && window.cnb.start( cnbConfig );  
        window.cnb && window.cnb.startconfig;           
    }

    template(_data: ncBannerOptions){
        this.el = makeElement( `
           <div class="nc-banner" data-type="top" id="ncTopBanner">
            <div class="nc-banner-inner" data-site="${_data.ip}">
                <span class="nc-banner-gradation-left"><span></span></span>
                <a href="${_data.topLink}" ${_data.topLinkNewWindow ? 'target=_blank' :''}  class="nc-banner-link">
                    <h2 class="nc-banner-title"><strong>${_data.topLable}</strong> ${_data.topTitle}</h2>
                    ${_data.ddayShow ? this._templateDDay(_data) : ''}
                    ${_data.topButtonShow ? `<span class="nc-banner-button">${_data.topButtonLable}</span>` : ``}
                    
                </a>
                <span class="nc-banner-gradation-right"><span></span></span>
            </div>
        </div>
        ` );

        return this.el;
    }

    _templateDDay(_data: ncBannerOptions){
        // 일본 표기법
        if(this._isLangJa){
            return `<span class="nc-banner-date"><span class="nc-banner-date-text">あと</span><em class="banner-date-num"></em><span class="nc-banner-date-text">日</span></span>`;
        // 그외 표기법
        }else{
            return `<span class="nc-banner-date"><span class="nc-banner-date-text">D-</span><em class="banner-date-num"></em></span>`;
        }
    }

    get _isLangJa(){           
        return document.querySelector('html')?.getAttribute('lang') === 'ja' || window.userData?.site === 'l2mncj'
    }

}
export default TopLayer;